module.exports = __webpack_public_path__ + "static/media/clock_oldDate.37196794.svg";